module.exports = __webpack_public_path__ + "img/emo_42.4fb6439d.gif";